import { useMemo } from 'react'
import { useLocation } from 'react-router'

const useQueryParams = () => {
  const { search } = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(search), [search])
  const params = Object.fromEntries(searchParams.entries())
  return params
}

export default useQueryParams
